/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action, computed } from '@ember/object';
import Component from '@glimmer/component';
import characterFromNumber from 'cio/utils/character-from-number';
import { task } from 'ember-concurrency';
import NewsletterModel from 'cio/models/newsletter';
import TemplateModel from 'cio/models/template';
import { tracked } from '@glimmer/tracking';

interface SendToRemainingModalArgs {
  newsletter: NewsletterModel;
  winnerTemplate: TemplateModel;
  isSendingNewsletter: boolean;
  onSend: ({
    timestamp,
    timezone,
    winnerTemplate,
  }: {
    timestamp?: number;
    timezone?: string;
    winnerTemplate: TemplateModel;
  }) => unknown;
  onClose: () => unknown;
}

export default class SendToRemainingModal extends Component<SendToRemainingModalArgs> {
  @tracked scheduleForFuture = false;
  /* eslint-disable-next-line ember/no-tracked-properties-from-args */
  @tracked winnerTemplate: TemplateModel = this.args.winnerTemplate;

  readonly scheduleOptions = Object.freeze([
    { value: false, label: 'Now' },
    { value: true, label: 'Schedule' },
  ]);

  constructor(owner: unknown, args: SendToRemainingModalArgs) {
    super(owner, args);
    this.setDefaults.perform();
  }

  @computed('newsletter.activeTemplates')
  get templates() {
    return this.args.newsletter.testVariations.map((template, index) => {
      return {
        label: `${characterFromNumber(index + 1)} - ${template.name}`,
        value: template.id,
      };
    });
  }

  private setDefaults = task(async () => {
    let { newsletter } = this.args;
    let winnerTemplate = await newsletter.get('winnerTemplate');

    if (winnerTemplate != null) {
      this.winnerTemplate = winnerTemplate;
    } else if (newsletter.activeTemplates.length === 1) {
      this.winnerTemplate = newsletter.activeTemplates[0];
    }

    if (newsletter.scheduledAt != null) {
      this.scheduleForFuture = true;
    }
  });

  @action
  didSelectWinnerTemplate(item: (typeof this.templates)[number]) {
    this.winnerTemplate = this.args.newsletter.activeTemplates.findBy('id', item.value);
  }

  @action
  sendNewsletter(options: { timezone: string; timestamp: number; tzMatchEnabled: boolean }) {
    return this.args.onSend({
      timestamp: options?.timestamp,
      timezone: options?.timezone,
      winnerTemplate: this.winnerTemplate,
    });
  }
}
